import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Camera, Sparkles, Monitor, Flame, Heart, Gift } from 'lucide-react';

const LandingFeatures = () => {
  const { t } = useTranslation();
  const FEATURES = [
    { icon: Camera, title: t('landing.feat1Title'), description: t('landing.feat1Desc'), color: 'text-blue-500', bg: 'bg-blue-500/10' },
    { icon: Sparkles, title: t('landing.feat2Title'), description: t('landing.feat2Desc'), color: 'text-purple-500', bg: 'bg-purple-500/10' },
    { icon: Monitor, title: t('landing.feat3Title'), description: t('landing.feat3Desc'), color: 'text-indigo-500', bg: 'bg-indigo-500/10' },
    { icon: Flame, title: t('landing.feat4Title'), description: t('landing.feat4Desc'), color: 'text-orange-500', bg: 'bg-orange-500/10' },
    { icon: Heart, title: t('landing.feat5Title'), description: t('landing.feat5Desc'), color: 'text-pink-500', bg: 'bg-pink-500/10' },
    { icon: Gift, title: t('landing.feat6Title'), description: t('landing.feat6Desc'), color: 'text-emerald-500', bg: 'bg-emerald-500/10' },
  ];

  return (
    <section className="py-20 sm:py-28 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-primary uppercase tracking-wider mb-2">{t('landing.everythingYouNeed')}</p>
          <h2 className="text-3xl sm:text-4xl font-bold">{t('landing.builtForFamilies')}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <Card key={i} className="group border-border/50 hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300">
              <CardContent className="p-6 space-y-3">
                <div className={`w-11 h-11 rounded-xl ${f.bg} flex items-center justify-center`}>
                  <f.icon className={`h-5 w-5 ${f.color}`} />
                </div>
                <h3 className="font-semibold text-base">{f.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{f.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingFeatures;
